<template>
    <!-- <div class="search-block w-[90%] mx-auto">
        <div class="flex justify-between mt-2">
            <InputComponent :value="searchQuery" @update:modelValue="e => searchQuery = e" placeholder="Пошук..." class="w-[250px]"/>
            <div class="filter w-[228px]">
                <ButtonComponent v-if="currentAdminRole != 'supervisor'" :fullWidth="true" @click="$emit('addTrainer')">Додати</ButtonComponent>
            </div>
        </div>
    </div> -->

    <div class="search-header">
        <div class="search-header__row">
            <SearchInput :modelValue="searchQuery" @update:modelValue="e => searchQuery = e" />
            <ButtonComponent @click="$emit('addTrainer')" v-if="currentAdminRole != 'supervisor'">Додати</ButtonComponent>
        </div>
    </div>
</template>

<script>
    import { ref, watch } from 'vue'

    export default {
        name: 'menu-bar',

        setup(props, { emit }) {
            const searchQuery = ref('')

            watch(searchQuery, (newValue) => {
                emit('search', newValue)
            })

            const currentAdminRole = ref(localStorage.getItem('userType'))

            return {
                searchQuery,
                currentAdminRole
            }
        }
    }
</script>
